import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction } from '@/api/manage';
import { queryIdTree, queryUserTreeList } from '@/api/api';
import moment from 'moment';
import IwsUpload from '@comp/upload/IwsUpload.vue';
import pick from 'lodash.pick';
export default {
  name: 'WorkPlanModal',
  components: {
    IwsUpload: IwsUpload
  },
  data: function data() {
    return {
      showType: 1,
      userInfo: this.$store.getters.userInfo,
      visible: false,
      model: {},
      labelCol: {
        span: 6
      },
      wrapperCol: {
        span: 14
      },
      departTreeData: [],
      userTree: [],
      dateFormat: 'YYYY-MM-DD HH:mm:ss',
      disabled: true,
      disableSubmit: true,
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        title: {
          rules: [{
            required: true,
            message: '请输入计划事项!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请选择牵头责任人!'
          }]
        },
        departId: {
          rules: [{
            required: true,
            message: '请选择责任科室!'
          }]
        },
        startTime: {
          rules: [{
            required: true,
            message: '请选择开始时间'
          }]
        },
        endTime: {
          rules: [{
            required: true,
            message: '请选择截止时间!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请选择状态!'
          }]
        }
      },
      rules: {
        title: {
          required: true,
          message: '请输入计划事项!'
        },
        userId: {
          required: true,
          message: '请选择牵头责任人!'
        },
        departId: {
          required: true,
          message: '请选择责任科室!'
        },
        startTime: {
          required: true,
          message: '请选择开始时间!'
        },
        endTime: {
          required: true,
          message: '请选择截止时间!'
        },
        status: {
          required: true,
          message: '请选择状态!'
        }
      },
      formList: [],
      setObj: {},
      index: 0
    };
  },
  props: ['handle'],
  created: function created() {
    this.loadDepartTree();
    this.loadTreeList();
  },
  methods: {
    loadDepartTree: function loadDepartTree() {
      var that = this;
      queryIdTree().then(function (res) {
        if (res.success) {
          that.departTreeData = res.result;
        }
      });
    },
    loadTreeList: function loadTreeList() {
      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          that.userTree = res.result;
        }
      });
    },
    moment: moment,
    deleteItem: function deleteItem(index) {
      if (this.formList.length > 1) {
        this.formList.splice(index, 1);
      }
    },
    addItem: function addItem(index) {
      this.formList.splice(index + 1, 0, _objectSpread({}, this.setObj));
    },
    add: function add() {
      var _this = this;

      this.showType = 1;
      setTimeout(function () {
        console.log(_this.$refs.ruleForm);

        _this.$forceUpdate();
      }, 3000);
      this.setObj = {
        title: '',
        userId: '',
        departId: '',
        relatedRequirements: '',
        remark: '',
        status: '1'
      };
      this.formList = [_objectSpread({}, this.setObj)];
      this.visible = true;
    },
    edit: function edit(record) {
      var _this2 = this;

      this.showType = 2;
      this.model = Object.assign({}, record);
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.$nextTick(function () {
        _this2.form.setFieldsValue(pick(_this2.model, 'title', 'userId', 'departId', 'relatedRequirements', 'status', 'remark'));

        _this2.form.setFieldsValue({
          startTime: _this2.model.startTime ? moment(_this2.model.startTime) : null,
          endTime: _this2.model.endTime ? moment(_this2.model.endTime) : null
        });
      });
      this.visible = true;
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
      this.disableSubmit = false;
    },
    handleOk: function handleOk(s, handle) {
      var _this3 = this;

      var that = this;

      if (this.showType == 1) {
        var p = new Promise(function (reslove, reject) {
          var list = [];

          _this3.$refs.ruleForm.forEach(function (e, i) {
            e.validate(function (val) {
              if (val) {
                list.push(1);
              }
            });
          });

          reslove(list);
        });
        p.then(function (list) {
          if (list.length == _this3.formList.length) {
            _this3.confirmLoading = true;

            var formList = _this3.formList.map(function (item) {
              var items = _objectSpread({}, item);

              items.startTime = moment(item.startTime).format('YYYY-MM-DD');
              items.endTime = moment(item.endTime).format('YYYY-MM-DD');
              return items;
            });

            console.log('formList', formList);
            httpAction('/work/tasks', formList, 'post').then(function (res) {
              if (res.success) {
                _this3.$message.success(res.message);

                _this3.$emit('ok');

                _this3.close();
              }
            }).finally(function () {
              _this3.confirmLoading = false;
            });
          }
        });
      } else {
        // 触发表单验证
        this.form.validateFields(function (err, values) {
          if (!err) {
            that.confirmLoading = true;
            var formData = Object.assign(_this3.model, values);
            formData.startTime = moment(formData.startTime).format('YYYY-MM-DD');
            formData.endTime = moment(formData.endTime).format('YYYY-MM-DD');

            if (handle) {
              formData.status = '2';
            }

            console.log('formData', formData);
            httpAction('/work/tasks', formData, 'put').then(function (res) {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
                that.close();
              } else {
                that.$message.warning(res.message);
              }
            }).finally(function () {
              that.confirmLoading = false;
            });
          }
        });
      }
    },
    handleCancel: function handleCancel() {
      this.$emit('ok');
      this.close();
    }
  }
};